export default {
  init() {
    // JavaScript to be fired on the home page

    var dpdFavourites = JSON.parse(window.localStorage.getItem('favourites'));

    if (dpdFavourites === null) {
      dpdFavourites = [];
    } else {
      $.each(dpdFavourites, function (index, item) {
        $('.dpd-card_fav.id-' + item).addClass('active');
      });
    }

    $('.dpd-card_fav').on('click', function (e) {
      e.preventDefault();

      const id = $(this).data('id');

      if ($(this).hasClass('active')) {
        $(this).removeClass('active');

        const index = dpdFavourites.indexOf(id.toString());
        if (index > -1) {
          dpdFavourites.splice(index, 1);
        }
      } else {
        $(this).addClass('active');

        dpdFavourites.push(id.toString());
      }

      window.localStorage.setItem('favourites', JSON.stringify(dpdFavourites));

      e.stopPropagation();
    });

    function fadeInOnScroll() {
      $('.pages-card').each(function (i) {
        const $this = $(this);
        const elementTop = $this.offset().top;
        const elementHeight = $this.outerHeight();
        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();

        const scrollBottom = scrollTop + windowHeight;
        const visibleHeight = scrollBottom - elementTop;

        if (
          !$this.hasClass('slide-up') &&
          visibleHeight > 0 &&
          visibleHeight >= elementHeight * 0.7
        ) {
          setTimeout(() => {
            $this.addClass('slide-up');
          }, i * 300); // Adjust delay as needed
        }
      });
    }

    fadeInOnScroll(); // Initial check
    $(window).on('scroll resize', fadeInOnScroll);

    const $video = $('.hero-video');
    const $button = $('#toggleVideo');
    const $pauseIcon = $button.find('.icon-pause');
    const $playIcon = $button.find('.icon-play');

    $button.on('click', function () {
      const videoEl = $video.get(0);

      if (videoEl.paused) {
        videoEl.play();
        $pauseIcon.removeClass('hidden');
        $playIcon.addClass('hidden');
        $button.attr('aria-label', 'Pause video');
      } else {
        videoEl.pause();
        $pauseIcon.addClass('hidden');
        $playIcon.removeClass('hidden');
        $button.attr('aria-label', 'Play video');
      }
    });


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js